export default "__VITE_ASSET__xw20b7h4__"